import Model from "./Model";
import TextModel from "./TextModel";
import VideoModel from "./VideoModel";
import ImageModel from "./ImageModel";
import QuestionModel from './QuestionModel';
import ArticleModel from './ArticleModel';
import SolutionModel from './SolutionModel';
import EssayReplyModel from './EssayReplyModel';
import AssertionModel from './AssertionModel';
import AnnotationModel from './AnnotationModel';

export default class ContentModel extends Model {
  id: number;
  position: number;
  textId: number;
  videoId: number;
  imageId: number;
  questionId: number;
  solutionId: number;
  articleId: number;
  essayReplyId: number;
  assertionId: number;
  annotationId: number;

  static __types: any = {
    image: ImageModel.__typename,
    video: VideoModel.__typename,
    text: TextModel.__typename
  }
  static __agreggators: any = {
    question: QuestionModel.__typename,
    article: ArticleModel.__typename,
    solution: SolutionModel.__typename,
    essayReply: EssayReplyModel.__typename,
    assertion: AssertionModel.__typename,
    annotation: AnnotationModel.__typename
  }
  static __typename: string = "Content";

  constructor(content: any, getters:any) {
    super(getters);
    this.id = content.id;
    this.position = content.position;
    this.textId = content.textByTextId || content.textId;
    this.videoId = content.videoByVideoId || content.videoId;
    this.imageId = content.imageByImageId || content.imageId;
    this.questionId = content.questionByQuestionId || content.questionId;
    this.solutionId = content.solutionBySolutionId || content.solutionId;
    this.articleId = content.articleByArticleId || content.articleId;
    this.essayReplyId = content.essayReplyByEssayReplyId || content.essayReplyId;
    this.assertionId = content.assertionByAssertionId || content.assertionId;
    this.annotationId = content.annotationByAnnotationId || content.annotationId;
  }
  behavior(): string {
    if (this.textId) {
      return "text";
    } else if (this.imageId) {
      return "image";
    } else if (this.videoId) {
      return "video";
    }
  }
  text(): TextModel {
    return this.getters.textById(this.textId);
  }
  image(): ImageModel {
    return this.getters.imageById(this.imageId);
  }
  video(): VideoModel {
    return this.getters.videoById(this.videoId);
  }
  length(): number {
    if (this.textId) {
      return this.text().body.length;
    } else {
      return 0;
    }
  }
  raw() {
    return {
      id: this.id,
      position: this.position,
      textId: this.textId,
      videoId: this.videoId,
      imageId: this.imageId,
      questionId: this.questionId,
      solutionId: this.solutionId,
      articleId: this.articleId,
      assertionId: this.assertionId,
      __typename: ContentModel.__typename
    }
  }
}